<template>
  <div class="swiper-slide">
    <div class="review-slide__outer">
      <svg xmlns="http://www.w3.org/2000/svg"
           width="60.816"
           height="52.138"
           viewBox="0 0 60.816 52.138">
        <g opacity="0.25">
          <!-- eslint-disable-next-line -->
          <path fill="#bebebe" d="M0 0v26.069h17.707A17.485 17.485 0 0 1 0 43.448v8.69c14.608 0 26.561-11.731 26.561-26.069V0zm34.255 0v26.069h17.707a17.485 17.485 0 0 1-17.707 17.379v8.69c14.608 0 26.561-11.731 26.561-26.069V0z"
                transform="rotate(180 30.408 26.069)" />
        </g>
      </svg>
      <div class="review-slide__inner text-center">
        <div v-html="decodedHtml"></div>
        <p class="name h3">{{slide.Name}}</p>
      </div>
      <div class="text-end">
        <svg xmlns="http://www.w3.org/2000/svg"
             width="60.816"
             height="52.138"
             viewBox="0 0 60.816 52.138">
          <g opacity="0.25">
            <!-- eslint-disable-next-line -->
            <path fill="#bebebe" d="M0 0v26.069h17.707A17.485 17.485 0 0 1 0 43.448v8.69c14.608 0 26.561-11.731 26.561-26.069V0zm34.255 0v26.069h17.707a17.485 17.485 0 0 1-17.707 17.379v8.69c14.608 0 26.561-11.731 26.561-26.069V0z"
                  transform="translate(0 4) translate(0 -4)" />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { decodeHtml } from '../helpers/html';
export default {
  name: 'ReviewCarouselSlide',
  props: {
    slide: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const decodedHtml = decodeHtml(props.slide.Content);
    return {
      decodedHtml
    };
  },
};
</script>
